import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRectangleHistoryCircleUser,
  faTags,
  faDolly,
  faHandshake,
  faCircleUser,
  faListCheck,
  faCartShopping,
} from "@fortawesome/pro-regular-svg-icons";

const SideMenu = {
  0: {
    label: "settings.users.account",
    icon: <FontAwesomeIcon icon={faCircleUser} className="mr-4 text-2xl" />,
    link: "/settings/account",
    permissions: ["ROLE_ADMIN", "ROLE_USER"],
  },
  1: {
    label: "settings.users.list",
    icon: (
      <FontAwesomeIcon
        icon={faRectangleHistoryCircleUser}
        className="mr-4 text-2xl"
      />
    ),
    link: "/settings/users",
    permissions: ["ROLE_ADMIN"],
  },
  2: {
    label: "settings.partners.list",
    icon: <FontAwesomeIcon icon={faHandshake} className="mr-4 text-2xl" />,
    link: "/settings/partners",
    permissions: ["ROLE_ADMIN"],
  },
  3: {
    label: "settings.items.categories",
    icon: <FontAwesomeIcon icon={faTags} className="mr-4 text-2xl" />,
    link: "/settings/categories",
    permissions: ["ROLE_ADMIN"],
  },
  4: {
    label: "settings.items.list",
    icon: <FontAwesomeIcon icon={faDolly} className="mr-4 text-2xl" />,
    link: "/settings/items",
    permissions: ["ROLE_ADMIN"],
  },
  5: {
    label: "settings.items.listUser",
    icon: <FontAwesomeIcon icon={faDolly} className="mr-4 text-2xl" />,
    link: "/settings/items",
    permissions: ["ROLE_USER"],
  },
  6: {
    label: "settings.orders.list",
    icon: <FontAwesomeIcon icon={faListCheck} className="mr-4 text-2xl" />,
    link: "/settings/orders",
    permissions: ["ROLE_ADMIN"],
  },
  7: {
    label: "settings.orders.listUser",
    icon: <FontAwesomeIcon icon={faListCheck} className="mr-4 text-2xl" />,
    link: "/settings/orders",
    permissions: ["ROLE_USER"],
  },
  8: {
    label: "shop.title",
    icon: <FontAwesomeIcon icon={faCartShopping} className="mr-4 text-2xl" />,
    link: "/",
    permissions: ["ROLE_ADMIN", "ROLE_USER", "ROLE_PARTNER"],
  },
};

export default SideMenu;
